var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ApplicationContext } from '../../../ApplicationContext';
import AssetTableRow from './AssetTableRow';
import AssetsControls from './AssetsControls';
import Routes from '../../../routes/RoutesConfig';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import TableModel from "../../../models/TableModel";
import { SystemFeatureToggle } from "../../../data/SystemFeatureToggle";
import Session from "../../../services/Session";
import Feature from "../../components/ui/Feature/Feature";
import Signals from "../../../signals/Signals";
/**
 *
 */
var AssetsTable = /** @class */ (function (_super) {
    __extends(AssetsTable, _super);
    /**
     *
     * @param props
     */
    function AssetsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { tableModel: new TableModel() };
        _this.setTableRef = _this.setTableRef.bind(_this);
        _this.onTableScroll = _this.onTableScroll.bind(_this);
        _this.onSortClick = _this.onSortClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetsTable.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onKeyDown);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetsTable.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.state, table = _a.table, tableContainer = _a.tableContainer;
        if (table) {
            if (tableContainer.scrollTop > table.offsetHeight) {
                table.scrollIntoView();
            }
        }
    };
    AssetsTable.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onKeyDown);
    };
    /**
     *
     */
    AssetsTable.prototype.render = function () {
        var _a = this.props, assetCollection = _a.assetCollection, viewState = _a.viewState;
        var tableModel = this.state.tableModel;
        if (!Session.isLoggedIn) {
            return (React.createElement(Navigate, { to: Routes.LOGIN.getPath() }));
        }
        return (React.createElement("div", { ref: this.setTableRef, className: "table-container h-100 w-100 d-flex flex-column" },
            React.createElement("div", { className: "d-flex justify-content-between ml-4 mb-4 pr-3 flex-wrap" },
                React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                    React.createElement(FormattedMessage, { id: "page.assets.title" })),
                React.createElement(AssetsControls, { assetCollection: assetCollection, viewState: viewState, tableModel: tableModel })),
            React.createElement("div", { className: 'overflow-auto' },
                React.createElement("div", { className: 'w-100', style: {
                        display: "grid",
                        // icon,id,make,model,serial,labels,service entries, battery, operating,location
                        gridTemplateColumns: "1fr 1fr 1fr 1fr minmax(auto,25%) 1fr 1fr" + (Session.user.hasAnySystemFeature([SystemFeatureToggle.SERVICEFEATUREPACK, SystemFeatureToggle.DEBUG]) ? " 1fr " : "") + " 2fr 3fr",
                        rowGap: "1.3rem",
                    } },
                    React.createElement("div", { className: 'w-100 position-sticky cursor-pointer text-nowrap text-uppercase bg-secondary px-1 pb-2 assetTableHeader', style: { display: "contents", top: 0, zIndex: 1 } },
                        React.createElement("div", null,
                            React.createElement(FormattedMessage, { id: "page.asset.table.column.icon" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "id" }, "#"),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "make" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.make" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "model" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.model" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "serialNumber" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.serialnumber" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "labels" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.labels" })),
                        React.createElement(Feature, { hasAny: [SystemFeatureToggle.SERVICEFEATUREPACK] },
                            React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "serviceEntries" },
                                React.createElement(FormattedMessage, { id: "page.assets.table.column.serviceentries" }))),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "batteryStatus" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.batterystatus" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "cumulativeOperatingHoursDurationInHours" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.operatinghours" })),
                        React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "place" },
                            React.createElement(FormattedMessage, { id: "page.assets.table.column.location" }))),
                    assetCollection.filtered.length > 0 ?
                        assetCollection.filteredAndSorted.map(function (assetModel, index) {
                            return React.createElement(AssetTableRow, { key: index + '-' + assetModel.id, assetModel: assetModel, compact: tableModel.compact });
                        }) : React.createElement(EmptyDivRow, null)),
                React.createElement("div", { className: "d-flex justify-content-center my-4" },
                    React.createElement(Link, { to: Routes.ASSETS_ARCHIVED.path },
                        React.createElement("button", { className: "btn btn-sm btn-outline-primary" },
                            React.createElement("i", { className: "fe fe-archive" }),
                            " ",
                            React.createElement(FormattedMessage, { id: "page.assets.archive.title" })))))));
    };
    AssetsTable.prototype.onKeyDown = function (event) {
        var _a = this.context, applicationModel = _a.applicationModel, assetCollection = _a.assetCollection;
        var assets;
        var index;
        if (event.target != document.body) {
            //key up/down was in a specific element (f.e. input), so ignore for navigating to prev/next asset
            //does not catch all scenarios but is for now the most robust solution
            return;
        }
        switch (event.keyCode) {
            //left/up
            case 37:
            case 38:
                assets = assetCollection.filteredAndSorted;
                index = assets.findIndex(function (model) { return applicationModel.selectedAsset === model; });
                if (index < 0)
                    return;
                var previousIndex = index - 1;
                if (previousIndex < 0) {
                    previousIndex += assets.length;
                }
                Signals.ShowAssetDetail.dispatch(assets[previousIndex]);
                break;
            // right/down
            case 39:
            case 40:
                assets = assetCollection.filteredAndSorted;
                index = assets.findIndex(function (model) { return applicationModel.selectedAsset === model; });
                if (index < 0)
                    return;
                var nextIndex = (index + 1) % assets.length;
                Signals.ShowAssetDetail.dispatch(assets[nextIndex]);
                break;
        }
    };
    /**
     *
     * @param event
     */
    AssetsTable.prototype.onSortClick = function (event) {
        var assetCollection = this.props.assetCollection;
        var sort = assetCollection.sort;
        var fieldName = event.target.dataset.sortby;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        assetCollection.sort.update({ fieldName: event.target.dataset.sortby, direction: direction });
        assetCollection.updateSortCache();
    };
    /**
     *
     */
    AssetsTable.prototype.onTableScroll = function () {
        var _a = this.state, thead = _a.thead, tableContainer = _a.tableContainer;
        thead.style.transform = 'translateY(' + tableContainer.scrollTop + 'px)';
        if (tableContainer.scrollTop < 5 && thead.classList.contains('box-shadow')) {
            thead.classList.remove('box-shadow');
        }
        if (tableContainer.scrollTop > 5 && !thead.classList.contains('box-shadow')) {
            thead.classList.add('box-shadow');
        }
    };
    /**
     *
     * @param ref
     */
    AssetsTable.prototype.setTableRef = function (ref) {
        if (ref) {
            var table = ref.querySelector('table');
            var thead = ref.querySelector('thead');
            this.setState({ table: table, thead: thead, tableContainer: ref });
            ref.addEventListener('scroll', this.onTableScroll);
        }
    };
    AssetsTable = __decorate([
        observer
    ], AssetsTable);
    return AssetsTable;
}(React.Component));
AssetsTable.contextType = ApplicationContext;
export default AssetsTable;
